import { Module } from "vuex";
/**
 * 项目案例-定制---北京vr定制
 * @type {Module}
 */
export const projectDetailCustomBeijingOne = {
  namespaced: true,
  state: {
    // 用户个性化需求数据
    objUserCustomListData: [
      {
        title: "家庭成员特点",
        sub: 3,
        children: [
          {
            icon: require("@/assets/images/vr/common/family-0.png"),
            text: ["5口之家，有老人"],
          },
          {
            icon: require("@/assets/images/vr/common/family-1.png"),
            text: ["家中有老人，体质较弱、怕冷"],
          },
        ],
      },
      {
        title: "日常痛点及需求",
        sub: 2,
        children: [
          {
            icon: require("@/assets/images/vr/common/demand-0.png"),
            text: ["“影音室”、“健身房”等区域使用频率低，需要快速采暖"],
          },
          {
            icon: require("@/assets/images/vr/common/demand-1.png"),
            text: ["家中长期有人采暖24小时开启费用高"],
          },
          {
            icon: require("@/assets/images/vr/common/demand-2.png"),
            text: ["冬季采暖门窗紧闭室内空气差"],
          },
          {
            icon: require("@/assets/images/vr/common/demand-3.png"),
            text: ["喜欢泡澡，热水水量要大"],
          },
          {
            icon: require("@/assets/images/vr/common/demand-4.png"),
            text: ["敏感肌肤，硬水洗浴皮肤干痒"],
          },
        ],
      },
      {
        title: "室温需求",
        sub: 4,
        children: [
          {
            icon: require("@/assets/images/vr/common/room-0.png"),
            text: ["冬季室温20℃不用穿厚外套 "],
          },
          {
            icon: require("@/assets/images/vr/common/room-1.png"),
            text: ["冬季儿童房22℃"],
          },
          {
            icon: require("@/assets/images/vr/common/room-2.png"),
            text: ["夏季室温26℃"],
          },
          {
            icon: require("@/assets/images/vr/common/room-3.png"),
            text: ["可分区控制"],
          },
        ],
      },
    ],
    // 设计参数数据
    objDesignParamsData: [
      {
        1: [
          {
            name: "空调面积",
            key: "energy_hot_area",
            value: "304㎡",
            util: "㎡",
          },
          {
            name: "采暖面积",
            key: "energy_hot_area",
            value: "390㎡",
            util: "㎡",
          },
          {
            name: "需求负荷",
            key: "energy_cold",
            value: "冷45.8kW",
            divide: 1000,
            before: "冷",
            util: "kW",
          },
          {
            name: "需求负荷",
            key: "energy_hot",
            value: "暖46kW",
            divide: 1000,
            before: "暖",
            util: "kW",
          },
          {
            name: "末端同开率",
            key: "energy_percent",
            value: "65%",
            util: "%",
          },
        ],
        3: [
          {
            name: "新风口",
            value: "22个",
            key: "numWindKou",
            util: "个",
          },
          {
            name: "换气面积",
            value: "305㎡",
            key: "numWindArea",
            util: "㎡",
          },
          {
            name: "换气频率",
            value: "1.1次/小时",
            key: "wind_exchange",
            util: "次/小时",
          },

          // {
          //   name: "新风需求量",
          //   value: "223.8㎡/hp",
          //   key: "wind_energy",
          //   util: "㎡/hp",
          // },
        ],
        4: [
          {
            name: "热水需求负荷",
            value: "55kW",
            key: "water_energy",
            util: "kW",
          },
          {
            name: "最大净水用量",
            key: "water_clean",
            value: "2.0t/h",
            util: "t/h",
          },
          {
            name: "热水设计流量",
            value: "30.00L/min",
            key: "water_rate",
            util: "L/min",
          },
          {
            name: "最大软水用量",
            value: "2.0t/h",
            key: "water_soft",
            util: "t/h",
          },
        ],
      },
    ],
    // 产品数据
    arrProductInfo: [
      {
        img: require("@/assets/images/vr/common/1.png"),
        name: "AI-LiNK 智能物联系统",
        id: 971,
      },
      {
        img: require("@/assets/images/vr/common/2.png"),
        name: "空调室外机",
        type: "AMVP-C33A",
        id: 944,
      },
      {
        img: require("@/assets/images/vr/common/3.png"),
        name: "空调风机盘管",
        type: "13台",
        id: 190, //此id为临时编的,之前是没有id的
      },
      // {
      //   img: require("@/assets/images/vr/common/4.png"),
      //   id: 191, //此id为临时编的,之前是没有id的
      //   name: "3D出风口",
      //   type: "APLC- DG",
      // },
      {
        img: require("@/assets/images/vr/common/5.png"),
        name: "冷凝采暖炉",
        type: "LN1GBQ52-S15",
        id: 417,
      },
      {
        img: require("@/assets/images/vr/common/6.png"),
        name: "热水储热水箱",
        type: "CHET-300SC",
        id: 426,
      },
      {
        img: require("@/assets/images/vr/common/7.png"),
        name: "中央新风",
        type: "ARV-25ADN",
        id: 932,
      },
      {
        img: require("@/assets/images/vr/common/8.png"),
        name: "前置过滤器 ",
        type: "PF - B1",
        id: 683,
      },
      {
        img: require("@/assets/images/vr/common/9.png"),
        name: "中央净水机",
        type: "ACWP-20AE1",
        id: 688,
      },
      {
        img: require("@/assets/images/vr/common/10.png"),
        name: "全屋美容软水机",
        type: "S20A1",
        id: 1045,
      },
      {
        img: require("@/assets/images/vr/common/11.png"),
        name: "净热饮一体机",
        type: "DR2000HA9",
        id: 530,
      },
    ],
    // 系统功能
    arrSystemFunctionList: [
      {
        name: "智能家居 稳定连接",
        video: require("@/assets/images/vr/common/media/zhinengjiaju.mp4"),
        cover: require("@/assets/images/vr/common/media/zhinengjiaju-cover.png"),
        open: true,
        id: 0,
      },
      {
        name: "智慧使用场景",
        video: require("@/assets/images/vr/common/media/zhihuishiyongchangjing.mp4"),
        open: false,
        id: 1,
      },
      {
        name: "设计、施工、售后数字化在线",
        video: require("@/assets/images/vr/common/media/shejishigongshouhou.mp4"),
        open: false,
        id: 2,
      },
      {
        name: "热浪采暖 短T过冬",
        video: require("@/assets/images/vr/common/media/relangcainuan.mp4"),
        open: false,
        id: 3,
      },
      {
        name: "绿色采暖 即开即享",
        video: require("@/assets/images/vr/common/media/lvsecainuan.mp4"),
        open: false,
        id: 4,
      },
      {
        name: "速热采暖 节能39%",
        video: require("@/assets/images/vr/common/media/surecainuan.mp4"),
        open: false,
        id: 5,
      },
      {
        name: "富氧新空气",
        image: require("@/assets/images/vr/common/media/fuyangxinkongqi.jpg"),
        open: false,
        id: 6,
      },
      {
        name: "节能新风",
        image: require("@/assets/images/vr/common/media/jienengxinfeng.jpg"),
        open: false,
        id: 7,
      },
      {
        name: "沐浴美容",
        image: require("@/assets/images/vr/common/media/muyumeirong.jpg"),
        open: false,
        id: 8,
      },
      {
        name: "全屋净水",
        image: require("@/assets/images/vr/common/media/quanwujingshui.jpg"),
        open: false,
        id: 9,
      },
      {
        name: "健康直饮水",
        image: require("@/assets/images/vr/common/media/jiankangzhiyingshui.jpg"),
        open: false,
        id: 10,
      },
      // {
      //   name: "沐浴热水 即开即来",
      //   image: require("@/assets/images/vr/common/media/muyureshui.jpg"),
      //   open: false,
      //   id: 11,
      // },
    ],
  },
  mutations: {
    /**
     * 改变系统功能容器的展开状态
     * @param state
     * @param typeAction
     * @constructor
     */
    CHANGE_SYSTEM_FUNC_VISIBLE(state, typeAction) {
      const { id } = typeAction;
      state.arrSystemFunctionList = state.arrSystemFunctionList.map((i) => {
        if (i.id === id) {
          i.open = !i.open;
        } else {
          i.open = false;
        }
        return i;
      });
    },
  },
};